<template>
    <div>
        <div class="">
            <router-view />
        </div>
    </div>
</template>

<script>
export default {
    name : 'authLayout'
}
</script>
<style lang="sass">
*
  margin: 0
  padding: 0
</style>
